<template>
  <div>
    <img src="@/assets/bells.svg" alt="" class="mx-auto relative z-20">
    <div class=" rounded-2xl bg-blue bg-opacity-80 p-2 relative score-wrapper -mt-3">
      <div class="stump">
        <div class="h-100 w-6 bg-white mr-8"></div>
        <div class="h-100 w-6 bg-white mr-8"></div>
        <div class="h-100 w-6 bg-white "></div>
      </div>
      <h2 class="text-2xl font-bold text-center my-5 text-shadow text-white w-full">Scoreboard</h2>
      <!--Biweekly  Top Score -->
      <!--
        <div class=" bg-white br-10 items-center mb-4">
          <div class="w-full bg-divider  p-3 br-t-10 ">
            <span class="text-xxs font-semibold rounded-sm   text-black text-center block">Biweekly Top Scorers</span>
          </div>
          <div class="pb-6">
            <ScoreCard v-for="(score,index) in weeklyScorers" :key="score.id" :scoreCard="score" :index="(index + 1)" />
          </div>
        </div>
      ------->
      <!-- Top Score -->
      <div class=" bg-white br-10 items-center mb-4">
        <div class="w-full bg-divider  p-3 br-t-10 ">
          <span class="text-xxs font-semibold rounded-sm   text-black text-center block"> Top Scorers</span>
        </div>
        <div class="pb-6">
          <ScoreCard v-for="(score,index) in topScorers" :scoreCard="score" :key="score.id" :index="(index + 1)" />
        </div>
      </div>
      <!-- Team Score -->
      <!-- <div class=" bg-white br-10 items-center mb-4">
        <div class="w-full bg-divider  p-3 br-t-10 ">
          <span class="text-xxs font-semibold rounded-sm   text-black text-center block"> Team Scorers</span>
        </div>
        <div class="pb-6">
          <ScoreCard v-for="(score,index) in teamScorers" :key="score.uuid" :scoreCard="score" :index="(index + 1)" />
        </div>
      </div> -->
    </div>
  </div>
</template>
<script type="text/javascript">
  export default {
    components:{
      ScoreCard: ()=>import(/* webpackChunkName: "ScoreCard" */'./ScoreCard.vue')
    },
    props:{
      weeklyScorers:{
        type:Array,
        default(){
          return [];
        }
      },
      topScorers:{
        type:Array,
        default(){
          return [];
        }
      },
      teamScorers:{
        type:Array,
        default(){
          return [];
        }
      }
    }
  }
</script>
<style type="text/css" scoped>
  .br-t-10 {
    border-radius: 10px 10px 0 0;
  }

  .stump {
    position: absolute;
    top: 0;
    content: '';
    height: 100%;
    width: 100%;
    z-index: -1;
    display: flex;
    justify-content: center;
  }

</style>